import { Component, OnInit } from '@angular/core';
import { UserTable } from 'src/app/services/models/user-table.model';
import { UserTableService } from 'src/app/services/user-table.service';

@Component({
  selector: 'bhub-manage-tables',
  templateUrl: './manage-tables.component.html',
  styleUrl: './manage-tables.component.scss',
  standalone: false
})
export class ManageTablesComponent implements OnInit {
  tables: UserTable[] = [];
  loading = false;
  showTableEditor = false;
  editingTable?: UserTable;

  constructor(private userTableService: UserTableService) {}

  ngOnInit() {
    this.loadTables();
  }

  loadTables() {
    this.loading = true;
    this.userTableService.getUserTables().subscribe({
      next: (tables) => {
        this.tables = tables;
        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading tables:', error);
        this.loading = false;
      }
    });
  }


  onEditTable(table: UserTable) {
    this.editingTable = table;
    this.showTableEditor = true;
  }

  onDeleteTable(table: UserTable) {
    if (confirm(`Are you sure you want to delete the table "${table.tableName}"?`)) {
      this.userTableService.deleteUserTable(table.tableId).subscribe({
        next: (success) => {
          if (success) {
            this.tables = this.tables.filter(t => t.tableId !== table.tableId);
          } else {
          }
        },
        error: (error) => {
        }
      });
    }
  }

  onCreateTable() {
    this.editingTable = undefined;
    this.showTableEditor = true;
  }

  onTableEditorSave(tableData: UserTable) {
    if (this.editingTable) {
      // Update existing table
      this.userTableService.updateUserTable(this.editingTable.tableId, tableData).subscribe({
        next: (updatedTable) => {
          const index = this.tables.findIndex(t => t.tableId === updatedTable.tableId);
          if (index !== -1) {
            this.tables[index] = updatedTable;
          }
          this.showTableEditor = false;
          this.editingTable = undefined;
        },
        error: (error) => {
          console.error('Error updating table:', error);
        }
      });
    } else {
      // Create new table
      this.userTableService.createUserTable(tableData).subscribe({
        next: (newTable) => {
          this.tables.push(newTable);
          this.showTableEditor = false;
        },
        error: (error) => {
          console.error('Error creating table:', error);
        }
      });
    }
  }

  onTableEditorCancel() {
    this.showTableEditor = false;
    this.editingTable = undefined;
  }
}
